<script>
    import StickyTopBar from '../Layout/StickyTopBar.svelte';
    import IssueTable from './issueTable.svelte';
    import {flagTypes} from '../../constants.js';
    import {updateUrlParam} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    import IssueBlurb from './IssueBlurb.svelte';

    export let type = flagTypes.improvement;
    export let status = 'OPEN';
    export let activityInstanceStatus = '';
    export let branchId = 270;
    export let branch = '';

    let topBarItems = [];

    $: topBarItems = [
        {
            name: sgettext('$$IMPROVEMENTS$$'),
            action: loadImprovements,
            active: type === flagTypes.improvement
        },
        {
            name: sgettext('$$ISSUES$$'),
            action: loadSupervisorIssues,
            active: type === flagTypes.help
        }
    ];



    function loadImprovements() {
        type = flagTypes.improvement;
        updateUrlParam('type', type);
        topBarItems.find(n => n.name === 'Improvements').active = true;
        delete topBarItems.find(n => n.name === 'Issues').active;

        topBarItems = [...topBarItems];
    }

    function loadSupervisorIssues() {
        type = flagTypes.help;
        updateUrlParam('type', type);
        topBarItems.find(n => n.name === 'Issues').active = true;
        delete topBarItems.find(n => n.name === 'Improvements').active;
        topBarItems = [...topBarItems];
    }
</script>

<style>
    .issue-page {
        overflow: auto;
        padding: 15px;
        height: calc(100% - 57px);
        width: 100%;
    }
</style>

<StickyTopBar items={topBarItems}></StickyTopBar>
<div class="issue-page">
    {#if type === flagTypes.help}
        <IssueBlurb />
    {/if}
    <IssueTable {type} {status} {branchId} {activityInstanceStatus}/>
</div>

